/**
 * ============================================================
 * GLOBAL AXIOS CLIENT
 * ============================================================
 * Single source of truth for all API requests.
 * - Configured with base URL
 * - Shared across entire application
 * - Interceptors attached for auth handling
 *
 * ⚠️ NEVER use axios directly - ALWAYS use this client
 * ============================================================
 */

import axios from "axios";
import { API_URL } from "../apiConfig";

const api = axios.create({
  baseURL: API_URL,
  withCredentials: false,
  timeout: 30000, // 30 second timeout
  headers: {
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
  },
});

export default api;
